var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FlatPickr',{staticClass:"flatpickr hidden",class:{ selected: _vm.values.length !== 0 },attrs:{"value":_vm.values,"config":_vm.config,"events":['onReady', 'onChange']},on:{"on-change":_vm.onChange,"on-ready":_vm.disableMonthSelect}})}
var staticRenderFns = []

export { render, staticRenderFns }